(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('InsuranceController', insuranceController)

  insuranceController.$inject = ['InsuranceService', 'NotificationService', 'ExthubConfigsService', 'PartnerCompanyService', 'FoundationApi', 'LangService']

  function insuranceController (InsuranceService, NotificationService, ExthubConfigsService, PartnerCompanyService, FoundationApi, LangService) {
    var vm                          = this;
    vm.show_form                    = true;
    vm.showGoBackButtonForInsurance = false;
    vm.btnCloseService              = '';
    vm.tentarNovamenteTrue          = false;
    vm.messageToOperator            = '';

    var form      = {}
    var payment   = {}
    var address   = {}
    var pensioner = {
      occupationAuxiliarCode: '9999-04',
      occupationCategory: 'OUTROS',
      insuranceCompany: 'INSS'
    }

    vm.proposalData = null
    vm.isSpecificOccupation = false

    LangService
      .getPageLabels({ 'page': 'menu.insurance.form-web' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang
      })

    function resetForm(sendAgain = null) {
      vm.show_form = true
      vm.show_token = false
      vm.show_proposal_number = false
      delete vm.insurance

      form = {
        _id: null,
        hashProposal: null,
        acceptTerm: '1',
        countryResident: '1',
        taxObligations: '0',
        isPolitical: '0',
        category: '1',
        nationality: '1',
        errorClass: 'field-error'
      }

      payment = {
        form: '',
        periodicity: '1'
      }

      address = {
        type: 'ENDERECO RESIDENCIAL'
      }

      vm.proposalData = null
      loadDefault()

      if (sendAgain) {
        vm.insurance.document = sendAgain
        vm.insurance.payment.document = sendAgain
      }
    }

    function loadDefault() {
      if (!vm.insurance) {
        vm.insurance = form
        vm.insurance.payment = payment
        vm.insurance.address = address
        vm.insurance.operatorData = {};
      } else {
        Object.assign(vm.insurance, form)
        Object.assign(vm.insurance.payment, payment)
        Object.assign(vm.insurance.addrss, address)
        Object.assign(vm.insurance.operatorData, {})
      }

      if(vm.partnerCompanies && vm.partnerCompanies.length == 1){
        vm.insurance.operatorData.expertCompany = vm.partnerCompanies[0].id;
      }
    }

    resetForm()
    getBanks()
    getState()
    getOccupationsCategories()
    getPartnerCompanies()
    getExthubConfigsInsurance()
    //saveOccupations()

    function getBanks() {
      InsuranceService.getBanks()
        .$promise
        .then(function (banks) {
          vm.banks = banks
        })
        .catch(function (error) {
        })
    }

    function getOccupationsCategories() {
      InsuranceService.getOccupationsCategories()
        .$promise
        .then(function (occupationsCategoriesList) {
          vm.occupationsCategoriesList = occupationsCategoriesList
        })
    }

    function getPartnerCompanies() {
      PartnerCompanyService.getAll()
        .$promise
        .then(function (partnerCompanies) {
          vm.partnerCompanies = partnerCompanies;
        })
    }

    function setupShowBackButton() {
      ExthubConfigsService
        .getConfig({ key: 'insurance.mag.show_go_back_button_for_insurance' })
        .$promise
        .then(function (data) {
          if (data.success == false) {
            NotificationService.errorHandler(data, 'Ocorreu um erro ao buscar configurações')
          } else {
            vm.showGoBackButtonForInsurance = data.result
          }
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, vm.labels.anErrorOccurredWhileFetchingTheSettings)
        })
    }

    function saveOccupations() {
      InsuranceService.saveOccupations()
        .$promise
        .then(function () {
        })
    }

    function setupOccupationField(code) {
      InsuranceService.getOccupationByCode({ code: code })
        .$promise
        .then(function (occupation) {
          if (occupation) {
            vm.ocuppationSelected = occupation
            vm.setOccupation({ selected: occupation })
          }
        })
    }

    function getOccupationCategoryByName(categoryName) {
      var category = null;
      var categoryResult = vm.occupationsCategoriesList.filter((item) => {
        return item.category === categoryName
      });

      if (categoryResult && categoryResult.length > 0) {
        category = categoryResult[0];
      }

      return category;
    }

    function setupFieldsForSpecificOccupation(selectedOccupation) {
      if (selectedOccupation.selected.auxiliar_code === pensioner.occupationAuxiliarCode) {
        vm.isSpecificOccupation = true;
        var occupationCategory = getOccupationCategoryByName(pensioner.occupationCategory);
        vm.insurance.occupationCategory = occupationCategory.category;
        vm.insurance.company = pensioner.insuranceCompany;
      } else {
        vm.isSpecificOccupation = false;
        vm.insurance.occupationCategory = '';
        vm.insurance.company = '';
      }
    }

    function getState() {
      const statesList = [
        { 'uf': 'AC', 'state': 'Acre' },
        { 'uf': 'AL', 'state': 'Alagoas' },
        { 'uf': 'AP', 'state': 'Amapá' },
        { 'uf': 'AM', 'state': 'Amazonas' },
        { 'uf': 'BA', 'state': 'Bahia' },
        { 'uf': 'CE', 'state': 'Ceará' },
        { 'uf': 'DF', 'state': 'Distrito Federal' },
        { 'uf': 'ES', 'state': 'Espírito Santo' },
        { 'uf': 'GO', 'state': 'Goías' },
        { 'uf': 'MA', 'state': 'Maranhão' },
        { 'uf': 'MT', 'state': 'Mato Grosso' },
        { 'uf': 'MS', 'state': 'Mato Grosso do Sul' },
        { 'uf': 'MG', 'state': 'Minas Gerais' },
        { 'uf': 'PA', 'state': 'Pará' },
        { 'uf': 'PB', 'state': 'Paraíba' },
        { 'uf': 'PR', 'state': 'Paraná' },
        { 'uf': 'PE', 'state': 'Pernambuco' },
        { 'uf': 'PI', 'state': 'Piauí' },
        { 'uf': 'RJ', 'state': 'Rio de Janeiro' },
        { 'uf': 'RN', 'state': 'Rio Grande do Norte' },
        { 'uf': 'RS', 'state': 'Rio Grande do Sul' },
        { 'uf': 'RO', 'state': 'Rondônia' },
        { 'uf': 'RR', 'state': 'Roraíma' },
        { 'uf': 'SC', 'state': 'Santa Catarina' },
        { 'uf': 'SP', 'state': 'São Paulo' },
        { 'uf': 'SE', 'state': 'Sergipe' },
        { 'uf': 'TO', 'state': 'Tocantins' }
      ]

      vm.statesList = statesList
    }

    vm.getBankInformations = function () {
      InsuranceService.getBankInformations({ bankCode: vm.insurance.payment.bankNumber })
        .$promise
        .then(function (bankInformations) {

          vm.accounts = bankInformations.accountTypes
          vm.agencyNumberQtyDigits = bankInformations.agencyNumberQtyDigits
          vm.agencyVerificationNumberQtyDigits = bankInformations.agencyVerificationNumberQtyDigits
          vm.accountNumberQtyDigits = bankInformations.accountNumberQtyDigits
          vm.accountVerificationNumberQtyDigits = bankInformations.accountVerificationNumberQtyDigits

          vm.showBankAgencyDigit = (bankInformations.agencyVerificationNumberQtyDigits === '') ? '' : true
          vm.showAccountDigit = (bankInformations.accountVerificationNumberQtyDigits === '') ? '' : true

          loadDefault()
        })
    }

    vm.loadClientDatas = function () {
      resetForm(vm.insurance.document)
      vm.showClientData = false;
      InsuranceService.loadClientDatas({ document: vm.insurance.document })
        .$promise
        .then(function (clientData) {
          if (clientData.success) {
            vm.showClientData = true;

            if (clientData.result && clientData.result.birthdate) {
              clientData.result.birthdate = new Date(clientData.result.birthdate + 'T12:00:00')
            }

            if (clientData.result && clientData.result.documents && clientData.result.documents.dateEmission) {
              clientData.result.documents.dateEmission = new Date(clientData.result.documents.dateEmission + 'T12:00:00')
            }

            if (clientData.result && clientData.result.phone.length >= 13) {
              clientData.result.phone = clientData.result.phone.substr(2)
            }

            Object.assign(vm.insurance, clientData.result)
            vm.insurance.payment.document = vm.insurance.document
            vm.insurance.payment.name = vm.insurance.fullName

            if (vm.insurance.payment.bankNumber) {
              vm.getBankInformations()
            }

            if (vm.insurance.occupationCode) {
              setupOccupationField(vm.insurance.occupationCode)
            }

            loadDefault()
          } else {
            NotificationService.errorHandler(clientData, clientData.message)
          }
        })
        .catch(function (error) {
          if (error.status == 404) {
            vm.showClientData = true;
            NotificationService.warningHandler(error, error.data)
          } else {
            NotificationService.errorHandler(error, error.data)
          }
          loadDefault()
        })
    }

    vm.autocompleteName = function () {
      vm.insurance.payment.name = vm.insurance.fullName
      loadDefault()
    }

    vm.sendProposal = function () {
      
      
      if (vm.insurance.occupationCode === '') {
        return NotificationService.warningHandler('', 'Informe a ocupação')
      }

      if (vm.insurance.paymentType === 'credit_card') {
        vm.insurance.payment.form = ''
        vm.insurance.payment.accountType = ''
        vm.insurance.payment.bankAccount = ''
        vm.insurance.payment.bankAccountDigit = ''
        vm.insurance.payment.bankAgency = ''
        vm.insurance.payment.bankAgencyDigit = ''
        vm.insurance.payment.bankNumber = ''
        vm.insurance.payment.dueDate = ''
        vm.insurance.payment.periodicity = ''
      }

      InsuranceService
        .sendProposal({ insurance: vm.insurance })
        .$promise
        .then(function (response) {
          if (response.success && response.data.paymentType === 'credit_card') {
            if (!response.data.success) {
              NotificationService.errorHandler(null, response.data.message);
              return;
            }

            vm.spinnerLoading = true
            vm.showMsgWaiting = true
            vm.showBtnBackToFormInModalWaitingPayment = false
            vm.msgWaitingPayment = true
            vm.msgPaymentError = false
            vm.proposalData = response.data.proposal

            timerScreenWaitingPayment()
            timerIntervalCheckPayment()

            FoundationApi.publish('sendPaymentLinkModal', 'open')
          }

          if (response.success && response.data.paymentType === 'debit_account') {
            vm.showClientData = false;
            vm.show_form = false
            vm.show_token = true
            vm.proposalData = response.data.proposal

            NotificationService.successHandler({}, vm.labels.insuranceProposalSuccessfullyRegistered)
            setupShowBackButton()
          }
        })
        .catch(function (error) {
          if (error.status == 400) {
            return NotificationService.warningHandler(error, error.data.message)
          }

          return NotificationService.errorHandler(error, error.data.message)
        })
    }

    vm.sendSignature = function () {
      InsuranceService
        .sendSignature({ insurance: vm.insurance })
        .$promise
        .then(function (response) {
          vm.show_token = false
          vm.show_proposal_number = true
          vm.proposalData.proposal_number = response.data
          NotificationService.successHandler({}, "Assinatura registrada com sucesso!")
        })
        .catch(function (error) {
          if (error.status == 422) {
            return NotificationService.warningHandler(error, error.data.message)
          }

          return NotificationService.errorHandler(error, error.data.message)
        })
    }

    vm.resendUserToken = function () {
      InsuranceService
        .resendUserToken(vm.proposalData)
        .$promise
        .then(function (tokenData) {
          NotificationService.successHandler({}, "Token reenviado com sucesso!")
        })
        .catch(function (error) {
          if (error.status == 422) {
            return NotificationService.warningHandler(error, error.data.message)
          }

          return NotificationService.errorHandler(error, error.data.message)
        })
    }

    vm.backToForm = function (reset = true) {
      if (reset) {
        resetForm()
        return
      }
      vm.showClientData = true;
      vm.show_form = true
      vm.show_token = false
    }

    vm.verifyIfAgeIsAllowedToGetInsurance = function () {
      InsuranceService
        .verifyIfAgeIsAllowedToGetInsurance({ birthdate: vm.insurance.birthdate })
        .$promise
        .then(function (ageIsAllow) {
          if (ageIsAllow.success === false) {
            vm.insurance.birthdate = ''
            return NotificationService.errorHandler(ageIsAllow, 'Operação não permitida! Cliente fora da faixa etária de contratação do plano.');
          }
        })
    }

    vm.getAddressByZipCode = function () {
      vm.insurance.address.addressDesc = ''
      vm.insurance.address.neighborhood = ''
      vm.insurance.address.city = ''
      vm.insurance.address.state = ''
      vm.insurance.address.complement = ''
      vm.insurance.address.number = ''

      InsuranceService
        .getAddressByZipCode({ zipCode: vm.insurance.address.zipcode })
        .$promise
        .then(function (address) {
          if (address.success === false) {
            return NotificationService.errorHandler(address, 'Endereço não localizado. Por favor, verifique se o CEP é válido ou preencha os dados manualmente.');
          }

          vm.insurance.address.addressDesc = address.logradouro
          vm.insurance.address.neighborhood = address.bairro
          vm.insurance.address.city = address.localidade
          vm.insurance.address.state = address.uf

        }).catch(function (error) {
          if (error.status == 400) {
            return NotificationService.warningHandler(error, error.data.message)
          }
        })
    }

    vm.filterCBO = function (select) {
      const searchText = select.search

      vm.occupationsList = []

      if (searchText.length > 2) {
        InsuranceService.getOccupations({ searchText: searchText })
          .$promise
          .then(function (filteredOccupations) {
            vm.occupationsList = filteredOccupations
          })
      }
    }

    vm.setOccupation = function (selectedOccupation, checkSpecificOccupation = false) {
      if (checkSpecificOccupation) {
        setupFieldsForSpecificOccupation(selectedOccupation);
      }

      vm.insurance.occupationCode = selectedOccupation.selected.auxiliar_code
      vm.insurance.occupation = selectedOccupation.selected.occupation
      vm.insurance.errorClass = ''
    }

    function timerScreenWaitingPayment() {
      let timer = vm.timerScreenWaitingPayment, minutes, seconds
      let countdown = setInterval(function () {
        if (vm.showBtnBackToFormInModalWaitingPayment) {
          clearInterval(countdown)
        }

        minutes = parseInt(timer / 60, 10)
        seconds = parseInt(timer % 60, 10)

        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds

        document.getElementById('waiting-time').innerHTML = minutes + ':' + seconds

        if (--timer < 0) {
          vm.spinnerLoading = false
          vm.showMsgWaiting = false
          vm.showBtnBackToFormInModalWaitingPayment = true
          clearInterval(countdown)
        }
      }, 1000)
    }

    function timerIntervalCheckPayment() {
      vm.intervalCheckPayment = setInterval(function () {
        InsuranceService
          .getProposalByHash({ hashProposal: vm.proposalData.hash_proposal })
          .$promise
          .then((response) => {
            if (!response.proposal.payment_response) {
              return
            }

            vm.tentarNovamenteTrue = false;
            if (response.proposal.payment_response.Mensagem.Pagamento.TentarNovamente) {
              vm.tentarNovamenteTrue = true;
            }

            if (response.proposal.payment_response.Mensagem.Pagamento.Autorizado == 'false' && 
              response.proposal.payment_response.Mensagem.Pagamento.CodigoRetorno != '1') {
                verifyMessage(response.proposal.payment_response.Mensagem.Pagamento.CodigoRetorno, 
                  response.proposal.payment_response.Mensagem.Pagamento.Bandeira);
                  
                  FoundationApi.publish('sendPaymentLinkModal', 'close');
                  FoundationApi.publish('sendPaymentError', 'open');
                  return;
            }

            clearInterval(vm.intervalCheckPayment)

            if (response.proposal.payment_response.Mensagem.Pagamento.Autorizado === 'false') {
              vm.msgWaitingPayment = false
              vm.msgPaymentError = true
              vm.spinnerLoading = false
              vm.showMsgWaiting = false
              vm.showBtnBackToFormInModalWaitingPayment = true

              return
            }

            FoundationApi.publish('sendPaymentLinkModal', 'close')

            vm.showClientData = false;
            vm.show_form = false
            vm.show_token = true
            vm.showGoBackButtonForInsurance = false
            vm.proposalData = response.proposal

            NotificationService.successHandler('', vm.labels.paymentConfirmed)
            sendUserTokenBySms()
          })
      }, vm.timerIntervalCheckPayment * 1000)
    }

    function verifyMessage(returnCode, cardFlag) 
    {
      InsuranceService
      .verifyMessage({CodigoRetorno: returnCode, BandeiraCartao: cardFlag})
      .$promise
      .then((response) => {
        vm.messageToOperator = response.message;
        return;
      }).catch((error) => {
        NotificationService.errorHandler('', vm.labels.errorFetchingMessage);
      })
    }

    function sendUserTokenBySms() {
      InsuranceService
        .sendUserTokenBySms({ hashProposal: vm.proposalData.hash_proposal })
        .$promise
        .then((response) => {
          if (response.success) {
            NotificationService.successHandler('', vm.labels.tokenSentBySms)
          }
        }).catch((error) => {
          NotificationService.errorHandler('', vm.labels.failedToSendTokenBySms)
        })
    }

    function getExthubConfigsInsurance() {
      ExthubConfigsService
        .getConfig({ key: 'insurance' })
        .$promise
        .then(function (response) {
          if (!response.success) {
            NotificationService.errorHandler('', vm.labels.anErrorOccurredWhileFetchingTheSettings)
            return
          }

          vm.timerScreenWaitingPayment = response.result.mag.creditCard.timerScreenWaitingPayment_seconds
          vm.timerIntervalCheckPayment = response.result.mag.creditCard.timerIntervalCheckPayment_seconds
        })
        .catch(function (response) {
          NotificationService.errorHandler(response, vm.labels.anErrorOccurredWhileFetchingTheSettings)
        })
    }

    vm.btnBackToFormInModalWaitingPayment = () => {
      clearInterval(vm.intervalCheckPayment)
    }

    vm.btnCloseService = function()
    {
      location.reload();  
    }
  }
})();
